(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
    const popup = document.querySelector('[data-sh-quote-popup]');
    if (!popup) return;

    const modal = popup.querySelector('.sh-quote-popup__modal');
    const closeButtons = popup.querySelectorAll('[data-sh-close-quote-popup]');

    const titleText = popup.querySelector('[data-sh-quote-popup-title]');
    const skuText = popup.querySelector('[data-sh-quote-popup-sku]');

    const titleField = popup.querySelector('[data-sh-quote-field-title]');
    const skuField = popup.querySelector('[data-sh-quote-field-sku]');
    const urlField = popup.querySelector('[data-sh-quote-field-url]');

    let lastFocusedElement = null;

    function getCurrentVariantData(button) {
      const productTitle =
        button.getAttribute('data-sh-quote-title') ||
        document.querySelector('[data-sh-product-title]')?.textContent?.trim() ||
        document.querySelector('h1')?.textContent?.trim() ||
        'Product';

    const productSku =
      button.getAttribute('data-sh-quote-sku') ||
      document.querySelector('[data-sku-output]')?.textContent?.trim() ||
      'N/A';

      const productUrl =
        button.getAttribute('data-sh-quote-url') ||
        window.location.href;

      return {
        title: productTitle,
        sku: productSku,
        url: productUrl
      };
    }

    function setPopupProductData(data) {
      if (titleText) titleText.textContent = data.title || 'Product';
      if (skuText) skuText.textContent = data.sku || 'N/A';

      if (titleField) titleField.value = data.title || 'Product';
      if (skuField) skuField.value = data.sku || 'N/A';
      if (urlField) urlField.value = data.url || window.location.href;
    }

    function openQuotePopup(button) {
      const productData = getCurrentVariantData(button);

      lastFocusedElement = document.activeElement;

      setPopupProductData(productData);

      popup.removeAttribute('hidden');
      popup.classList.add('is-active');

      document.documentElement.classList.add('sh-quote-popup-open');
      document.body.classList.add('sh-quote-popup-open');

      setTimeout(function () {
        const firstInput = popup.querySelector('input:not([type="hidden"]), textarea, button');
        if (firstInput) firstInput.focus();
      }, 100);
    }

    function closeQuotePopup() {
      popup.classList.remove('is-active');

      document.documentElement.classList.remove('sh-quote-popup-open');
      document.body.classList.remove('sh-quote-popup-open');

      setTimeout(function () {
        popup.setAttribute('hidden', 'hidden');

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
      }, 250);
    }

    document.addEventListener('click', function (event) {
      const openButton = event.target.closest('[data-sh-open-quote-popup]');

      if (openButton) {
        event.preventDefault();
        openQuotePopup(openButton);
        return;
      }

      const closeButton = event.target.closest('[data-sh-close-quote-popup]');

      if (closeButton) {
        event.preventDefault();
        closeQuotePopup();
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeQuotePopup();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (!popup.classList.contains('is-active')) return;

      if (event.key === 'Escape') {
        closeQuotePopup();
      }

      if (event.key === 'Tab' && modal) {
        const focusableElements = modal.querySelectorAll(
          'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );

        if (!focusableElements.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    });

    popup.addEventListener('click', function (event) {
      if (event.target === popup) {
        closeQuotePopup();
      }
    });

    document.addEventListener('shopify:section:load', function () {
      const refreshedPopup = document.querySelector('[data-sh-quote-popup]');
      if (!refreshedPopup) return;
    });
  });
})();